import Logotype from "./Logotype";
import { useAuth } from "hooks/auth";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CachedIcon from "@mui/icons-material/Cached";
import LogoutIcon from "@mui/icons-material/Logout";

export default function Topbar() {
  const { auth, setAuth } = useAuth();

  const logout = () => {
    setAuth({ isLoggedIn: false });
  };

  return (
    <AppBar elevation={0} position="fixed" color="default">
      <Toolbar variant="dense" sx={{ pl: 2, pr: 2 }} disableGutters>
        <Box sx={{ flexGrow: 1 }}>
          <Logotype />
        </Box>
        {auth.isLoggedIn && (
          <>
            <IconButton
              size="small"
              edge="end"
              aria-label="reload"
              aria-controls="reload"
              aria-haspopup="true"
              onClick={() => window.location.reload()}
              color="inherit"
            >
              <CachedIcon />
            </IconButton>
            <IconButton
              size="small"
              edge="end"
              aria-label="logout"
              aria-controls="logout"
              aria-haspopup="true"
              onClick={logout}
              color="inherit"
            >
              <LogoutIcon />
            </IconButton>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}
